// extracted by mini-css-extract-plugin
export default {"mainImage":"AutoDelivery_mainImage__Kh1l0"};